module.exports = __webpack_public_path__ + "img/banner2.7c1bf38a.png";